import { DeliveryProvider } from '@context/Delivery';
import DeliveryView from './DeliveryView';

const Delivery = () => {
  return (
    <DeliveryProvider>
      <DeliveryView />
    </DeliveryProvider>
  );
};

export default Delivery;
